import React from 'react'

import TaxControlTriangle from './TaxControlTriangle'

const App = props => {
  const {
    descriptionContent,
    titleContent,
    topContent,
    middleContent,
    bottomContent,
    imageContentOne,
    imageContentTwo,
    imageContentThree,
    imageContentFour,
    rothiraContent,
  } = props.content

  return (
    <div className='u-sizeConstrained u-paddingVert8gu u-paddingHoriz14gu u-bgColorLight u-pt-paddingVert0 pt-bgColorWhite pt-break-after'>
      <TaxControlTriangle
        descriptionContent={descriptionContent}
        titleContent={titleContent}
        topContent={topContent}
        middleContent={middleContent}
        bottomContent={bottomContent}
        imageContentOne={imageContentOne}
        imageContentTwo={imageContentTwo}
        imageContentThree={imageContentThree}
        imageContentFour={imageContentFour}
        rothiraContent={rothiraContent}
      />
    </div>
  )
}

export default App
